module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kb-home"
  }, [_c('div', {
    staticClass: "panel h1-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/kb"
    }
  }, [_vm._v("Knowledge Base")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "panel search-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("How can we help?")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.goToSearchQueryUrl()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search for a topic (lighting, texturing, ...)"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.getSearchQueryLocation()
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "panel category-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("Browse by Category")]), _vm._v(" "), (!_vm.isLoadingCategories) ? _c('ol', _vm._l((_vm.categories), function(category) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": _vm.getCategoryLocation(category)
      }
    }, [(category.imageUrl) ? _c('img', {
      staticClass: "category-image",
      attrs: {
        "src": category.imageUrl
      }
    }) : _c('img', {
      staticClass: "category-image",
      attrs: {
        "src": require("../assets/img/ttto-thumbnail.jpg")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "category-label-wrapper"
    }, [_c('div', {
      staticClass: "category-label"
    }, [_vm._v(_vm._s(category.label))]), _vm._v(" "), _c('div', {
      staticClass: "category-article-count"
    }, [_vm._v(_vm._s(_vm.toArticleText(category.articleCount)))])])])], 1)
  })) : _c('div', {
    staticClass: "loading-msg"
  }, [_vm._v("\n                Loading...\n            ")])])]), _vm._v(" "), (_vm.canAuthor) ? _c('section', {
    staticClass: "panel new-article-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('kb-block-link', {
    attrs: {
      "title": "Create an article",
      "to": _vm.getArticleEditorLocation()
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('kb-feedback')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a7c8500!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KbHome.vue
// module id = 1985
// module chunks = 2